<template>
  <div id="the-ing">
    <div class="box" id="verb-box" @click="upAndDown">
      <h4 class="h4-top">{{ items[18].text }}</h4>
      <h3 class="h3-top">{{ items[19].text }}</h3>
      <h2>{{ accord(items[20].text) }}</h2>
      <h3 class="h3-bottom">{{ items[21].text }}</h3>
      <h4 class="h4-bottom">{{ items[22].text }}</h4>
    </div>
    <div class="box" id="ing-box">
      <h2>-ing</h2>
    </div>
  </div>
</template>

<script>
import verbs from '@/assets/verbs'
export default {
  data: () => {
    return {
      items: verbs,
      lastIndex: 0
    }
  },
  methods: {
    upAndDown () {
      // this.items.splice(0, 0, this.items[this.lastIndex])
      var x = this.items.pop()
      this.items.unshift(x)
    },
    accord (verb) {
      if (verb === 'lose') {
        return 'loos'
      } else if (verb === 'begin') {
        return 'beginn'
      } else if (verb[verb.length - 1] === 'e' && verb !== 'be') {
        let accordingVerb = verb.substring(0, verb.length - 1)
        return accordingVerb
      } else if (verb[verb.length - 1] === 't' && verb !== 'eat') {
        let accordingVerb = verb + 't'
        return accordingVerb
      } else {
        return verb
      }
    }
  },
  created: function () {
    window.onscroll = () => {
      if (document.documentElement.scrollTop < 50) {
        this.upAndDown()
      } else {
        console.log('else')
      }
      // this.lastIndex = this.items.length - 1
      // console.log(this.lastIndex)
    }
  }
}
</script>

<style>
html{
  font-size: 24px;
}
body{
  background: blue;
  color: white;
}
.box{
  width: calc(50vw - 40px);
  height: calc(100vh - 40px);
  border: 2px solid white;
  display: inline-block;
  position: fixed;
  padding: 10px;
}
#ing-box{
  right: 10px;
  text-align: center;
}
h2, h3, h4, h5{
  position: fixed;
}
h3, h4, h5{
  font-weight: normal;
}
#ing-box h2{
  left: 70vw;
}
#verb-box h2{
  left: 17vw;
}
h2{
  top: 35vh;
}
.h3-bottom{
  top: 55vh;
  left: 8vw;
}
.h3-top{
  top: 20vh;
  left: 8vw;
}
.h4-bottom{
  top: 70vh;
  left: 5vw;
}
.h4-top{
  top: 5vh;
  left: 5vw;
}
</style>



// WEBPACK FOOTER //
// src/components/TheIng.vue